import jwtDecode from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PagePath from '../../PagePath';
import { DISTRIBUTORUSERTYPE } from '../../../constants/selects';
import useCreateDistributorUser from '../../../hooks/distributorUser/useCreateDistributorUser';
import useCreateDistributorUserMaster from '../../../hooks/distributorUser/useCreateDistributorUserMaster';
import useUpdateDistributorUser from '../../../hooks/distributorUser/useUpdateDistributorUser';
import { checkAdmin } from '../../../services/validation';
import { ApplicationState } from '../../../store';
import ActivityIndicator from '../../ActivityIndicator';
import FooterForm from '../../FooterForm';
import '../styles.scss';

const FormUserAdmin: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { execute, loading } = useCreateDistributorUser();
  const { execute: executeRegisterMaster, loading: loadingRegisterMaster } =
    useCreateDistributorUserMaster();
  const { execute: executeUpdateDistributorUser, loading: loadingUpdate } =
    useUpdateDistributorUser();
  const token = useSelector(
    (state: ApplicationState) => state.auth.token || state.distributor.token,
  );
  const { rows } = useSelector(
    (state: ApplicationState) => state.tables.distributors,
  );
  const { email, username, distributorUserType, status } = useSelector(
    (state: ApplicationState) => state.distributorUser,
  );

  const [distributorUser, setDistributorUser] = useState({
    username: username,
    email: email,
    password: '',
    distributorUserType: distributorUserType || DISTRIBUTORUSERTYPE[1].value,
    status: status,
  });
  const [distributorId, setDistributorId] = useState('');

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (checkAdmin(token) && !id) {
      return await executeRegisterMaster(distributorId, distributorUser);
    }
    if (id) {
      return await executeUpdateDistributorUser(id, distributorUser);
    } else {
      return await execute(distributorUser);
    }
  };

  // useEffect(() => {
  //   if (checkAdmin(token)) {
  //   }
  // }, []);

  if (loading || loadingRegisterMaster || loadingUpdate) {
    return <ActivityIndicator />;
  }

  return (
    <>
      <div className="container-form-user">
        <Form onSubmit={(event: React.FormEvent) => handleSubmit(event)}>
          <Col className="container-body">
            <Form.Label>Nome de Usuário *</Form.Label>
            <Form.Control
              value={distributorUser.username}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setDistributorUser({
                  ...distributorUser,
                  username: event.target.value,
                })
              }
              className="form-control"
            />
            <Form.Label>Email do Usuário *</Form.Label>
            <Form.Control
              value={distributorUser.email}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setDistributorUser({
                  ...distributorUser,
                  email: event.target.value,
                })
              }
              className="form-control"
              required
            />

            <Form.Label> Distribuidora </Form.Label>
            <Form.Control
              as="select"
              defaultValue={distributorUser.distributorUserType}
              onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                setDistributorId(event.target.value)
              }
              required
              placeholder="Selecione..."
            >
              <option value="">Selecione</option>
              {rows.map((option, index) => (
                <option value={option.distributorId} key={index}>
                  {option.name}
                </option>
              ))}
            </Form.Control>
          </Col>
          <FooterForm id={id ? id : ''} />
        </Form>
      </div>
    </>
  );
};

export default FormUserAdmin;
